import { AccessoryServiceViewModel } from "src/app/view-models/orders/accessory-service.view-model";
import { StoredAccessoryService } from "../models/stored-orders/stored-accessory-service";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between AccessoryService view model and database StoredAccessoryService.
 */
export class AccessoryServiceMapper implements IStoredMapper<AccessoryServiceViewModel, StoredAccessoryService> {
	/**
	 * Maps a AccessoryServiceViewModel to a StoredAccessoryService.
	 * @param accessoryService The accessory service data to convert.
	 * @returns A StoredAccessoryService object.
	 */
	public ToStored(accessoryService: AccessoryServiceViewModel): StoredAccessoryService {
		return {
			ServiceName: accessoryService.ServiceName,
			Quantity: accessoryService.Quantity
		};
	}

	/**
	 * Maps a StoredAccessoryService to a AccessoryServiceViewModel.
	 * @param storedAccessoryService The stored accessory service data to convert.
	 * @returns A AccessoryServiceViewModel object.
	 */
	public FromStored(storedAccessoryService: StoredAccessoryService): AccessoryServiceViewModel {
		return {
			ServiceName: storedAccessoryService.ServiceName,
			Quantity: storedAccessoryService.Quantity
		};
	}
}